<template>
  <div class="form-group text-center mb-2">
    <a href="#" class="btn btn-outline-primary px-3" @click.prevent="$emit('more', 7)">
      <i class="fa fa-calendar mr-1" />
      Pick Another Day
    </a>
  </div>
</template>

<script charset="utf-8">
export default {
  name: "LoadMore",
};
</script>
